var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeechBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 141,
    viewBox: "0 0 127 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65,
    cy: 65.5,
    rx: 31,
    ry: 31.5,
    fill: "#92E3A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0747 1.87579C66.9237 -0.473926 81.1604 1.93712 93.4634 8.71585C105.767 15.4946 115.41 26.2412 120.823 39.2035C126.235 52.1659 127.097 66.5794 123.267 80.0943C119.438 93.6092 111.143 105.428 99.7352 113.624",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1538 12.7012C32.9227 8.5425 39.3628 5.40526 46.1934 3.42616",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3963 117.473C25.0164 112.831 17.8238 106.313 12.3806 98.4297C6.93738 90.5464 3.39109 81.511 2.01895 72.0298C0.646818 62.5487 1.48601 52.8786 4.4709 43.7756C7.4558 34.6726 12.5056 26.3832 19.2254 19.5554",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4178 137.084L26.7051 140.361L32.4849 120.601",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9235 124.409C64.7804 125.985 55.3996 125.478 46.4793 122.927L34.77 133.262",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1758 120.179C85.859 121.175 83.4838 122.029 81.0632 122.736",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0817 32.9103C76.7848 34.227 83.7159 38.3795 88.5108 44.5504C93.3056 50.7212 95.617 58.4634 94.9897 66.253C94.3625 74.0425 90.8421 81.3151 85.1216 86.6393C79.4011 91.9634 71.8948 94.9533 64.0803 95.0205C56.2658 95.0877 48.7093 92.2273 42.898 87.0024C37.0868 81.7774 33.4419 74.5664 32.6808 66.7888C31.9196 59.0112 34.0975 51.2304 38.7856 44.978C43.4736 38.7256 50.3323 34.4545 58.0116 33.0055",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0253 97.8896C48.9673 96.3464 40.893 91.2688 35.5781 83.7734C30.2633 76.278 28.143 66.9786 29.6835 57.9201",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4309 75.4501C94.298 81.3485 90.6054 86.5579 85.7462 90.5238C80.887 94.4897 75.0433 97.0635 68.8372 97.9712",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3491 49.2843C35.8611 41.6527 42.026 35.5569 49.6966 32.131C57.3672 28.7051 66.0212 28.1824 74.0483 30.6602C82.0755 33.1381 88.9292 38.4476 93.3341 45.601C97.7391 52.7544 99.3954 61.2645 97.9948 69.5478",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6267 51.2563L85.0347 50.8211",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0779 57.2401L81.8522 54.2618",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2144 61.6192L58.5556 79.3532L76.6568 59.8513",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/speech_bubble.f2faeef3cf4770525a6c599edfbcf2c8.svg";
export { ForwardRef as ReactComponent };